import { AxiosRequestConfig } from 'axios';

import { IS_CLIENT_SIDE } from 'constants/constants';
import { DataDogWrapper } from 'lib/dataDog';
import { maskSensitiveData } from 'src/shared/lib/logging';

export class Logger {
  public static log(message: any, ...rest: Array<any>) {
    DataDogWrapper.captureLog(message, ...rest);
  }

  public static warn(warn: any, ...rest: Array<any>) {
    DataDogWrapper.captureWarn(warn, ...rest);
  }

  public static error(error: any, ...rest: Array<any>) {
    DataDogWrapper.captureException(error, ...rest);
  }
}

export const logRequestMetadata = (
  config: AxiosRequestConfig,
  isMobile: boolean,
  status?: number,
  message?: string,
) => {
  if (!config) {
    return console.log('No request data is presented');
  }

  if (IS_CLIENT_SIDE) {
    return;
  }

  const endTime = new Date().getTime();
  try {
    const safeHeaders = { ...config.headers };

    Object.keys(safeHeaders).forEach((key) => {
      if (key.toLowerCase() === 'cookie') {
        delete safeHeaders[key];
      }
    });

    const body = typeof config.data === 'string'
      ? config.data
      : JSON.stringify(config.data, null, 2);

    console.log(
      isMobile
        ? 'Request to Mobile API \n'
        : 'Request to CMS Proxy \n',
      `URL: ${config.baseURL}/${config.url};\n`,
      `Method: ${config.method};\n`,
      (status)
        ? `Status: ${status};\n`
        : `API ERROR occurred; Message: ${message || '-'}\n`,
      `Headers: ${maskSensitiveData(JSON.stringify(safeHeaders, null, 2))};\n`,
      (config.params)
        ? `Params: ${maskSensitiveData(JSON.stringify(config.params, null))};\n`
        : '',
      (config.method?.toLowerCase() === 'post')
        ? `Body: ${maskSensitiveData(body)};\n`
        : '',
      // @ts-ignore
      `Duration: ${endTime - config.metadata.startTime} ms;`,
    );
  } catch (e) {
    console.error(
      'Error ocurred for Request to Mobile API \n',
      'Probably something wrong with headers/body/params \n',
      `URL: ${config.baseURL}/${config.url};\n`,
      `Method: ${config.method};\n`,
      // @ts-ignore
      `Duration: ${endTime - config.metadata.startTime} ms;`,
    );
  }
};
